export const pagesContractEn = {
  title: "Contracts",
  detail: {
    header: {
      status: "Status",
      renewalDate: "Renewal Date",
      noRenewalDate: "No Renewal Date",
      dataLoadFailed: "Failed to load contract header data",
    },
    tabs: {
      detail: "Detail",
      structure: "Structure",
      riskProvisions: "Risk Provisions",
      approvalInfo: "Approval Info",
      history: "History",
      operationActivity: "Operation Activity",
      rulesPolicy: "Rules & Policy",
    },
    body: {
      groups: {
        commonInformation: "Common Information",
        employmentContract: "Employment Contract",
        leaseContract: "Lease Contract",
        serviceContract: "Service Contract",
      },
      sections: {
        contractIdInfo: "Contract ID Information",
        contractTerms: "Contract Terms",
        employmentTerms: "Employment Terms & Contract",
        worksiteMaster: "Worksite Master",
        workingTimeShifts: "Working Time & Shifts",
        compensation: "Compensation",
        benefitsInternalPolicies: "Benefits & Internal Policies",
      },
      noDataMessage: "No data available in this section.",
      errors: {
        dataLoadFailed: "Failed to load data",
        unknownError: "An unknown error occurred",
        contractNotFound: "Contract details not found",
        contractIdLabel: "Contract ID: {{id}}",
      },
    },
  },
  comingSoon: {
    overview: {
      title: "Contract Overview",
      description: "Contract overview dashboard is coming soon.",
    },
    people: {
      title: "Contract People",
      description: "Contract people management is coming soon.",
    },
    alerts: {
      title: "Contract Alerts",
      description: "Contract alerts and notifications are coming soon.",
    },
    contractAndCost: {
      title: "Contract & Cost",
      description: "Contract and cost management is coming soon.",
    },
    operationActivity: {
      title: "Operation Activity",
      description: "Contract operation activity tracking is coming soon.",
    },
    defaultDescription: "This page is coming soon. Please check back later.",
  },
  add: {
    intro: {
      header: {
        headerTitle: "Add contract data to your registry",
        description: "",
      },
      body: {
        selectContractType: "Select the Contract Type:",
        fillOutDetails: "Fill out details",
        itemCard: {
          title: {
            lease_asset: "Lease Asset",
            software: "Software",
            contractor_vendor: "Contractor & Vendor",
            employment: "Employment",
          },
          requiredDetails: "Required details:",
          contractTitle: "Contract title",
          vendor: "Vendor",
          employee: "Employee",
          contractTerm: "Contract term",
          amount: "Amount",
          salary: "Salary",
        },
      },
      options: {
        description: "Or you might want to...",
        bulkCsvUpload: {
          title: "Bulk add by uploading a csv file",
          description:
            "You can add data for multiple contracts, up to 500 records at a time. A CSV file following the DRESS CODE format is required.",
          selectedContractType: "Contract type:",
          selectedContractTypeTitle: {
            lease_asset: "Lease Asset",
            software: "Software",
            contractor_vendor: "Contractor & Vendor",
            employment: "Employment",
            all: "All Contracts",
          },
          button: "Prepare csv file",
        },
        syncExternalSystem: "Sync with external contract management systems",
        existingContracts: "Select from existing contract templates",
      },
    },
  },
  importCsv: {
    contractType: {
      title: {
        leaseAsset: "Lease Asset Bulk Import",
        software: "Software Contract Bulk Import",
        contractorVendor: "Contractor & Vendor Contract Bulk Import",
        employment: "Employment Contract Bulk Import",
        all: "All Contracts Bulk Import",
      },
      filename: {
        leaseAsset: "LeaseAsset",
        software: "Software",
        contractorVendor: "ContractorVendor",
        employment: "Employment",
        all: "AllContracts",
      },
      prepareCsvFile: {
        templateTitle: {
          leaseAsset: "New lease asset contracts",
          software: "New software contracts",
          contractorVendor: "New contractor & vendor contracts",
          employment: "New employment contracts",
          all: "New contracts",
        },
        updateExisting: {
          leaseAsset: "Update existing lease asset contracts",
          software: "Update existing software contracts",
          contractorVendor: "Update existing contractor & vendor contracts",
          employment: "Update existing employment contracts",
          all: "Update existing contracts",
        },
      },
      unit: {
        leaseAssets: "lease asset contracts",
        software: "software contracts",
        contractorVendors: "contractor & vendor contracts",
        employments: "employment contracts",
        contracts: "contracts",
      },
    },
    completeDialog: {
      button: "Done",
    },
    table: {
      columns: {
        contractTitle: "Contract Title",
        vendor: "Vendor",
        contractStartDate: "Contract Start Date",
        contractEndDate: "Contract End Date",
        amount: "Amount",
      },
    },
    checkValidColumn: {
      errors: "errors",
    },
  },
};
